<div class="widget-card enhanced-kpi-widget" [ngClass]="widthClass">
  <div class="widget-header">
    <div class="chart-title">
      <span class="title-text">{{ widgetTitle }}</span>
    </div>
    <gains-ellipsis-menu 
      *ngIf="menuItems.length > 0" 
      class="ellipsis-button" 
      [menuItems]="menuItems" 
      (changeEvent)="handleMenuAction($event)">
    </gains-ellipsis-menu>
  </div>
  
  <!-- Main KPI Section -->
  <div class="kpi-metric-section">
    <div class="kpi-content">
      <span 
      class="kpi-value" 
      [ngClass]="[valueClass, hasComparisonData ? 'kpi-value--compact' : '']"
      [attr.aria-label]="hasData ? ('Current ' + widgetTitle.toLowerCase() + ': ' + value + ' ' + unit) : (widgetTitle + ' data not available')">
      {{ hasData ? value : noDataValue }}
    </span>
    <span class="kpi-label" *ngIf="unit">{{ unit }}</span>
    </div>
  </div>

  <!-- Period Comparison Section -->
  <div class="comparison-section" *ngIf="hasData && hasComparisonData; else noDataTemplate">
    <!-- Divider -->
    <div class="divider"></div>

    <!-- Period Comparison -->
    <div class="period-comparison">
      <!-- Versus Row -->
      <div class="period-row">
        <span class="period-row__label">Versus</span>
        <span 
          [ngClass]="comparisonData!.versusPercentClass"
          [attr.aria-label]="comparisonData!.versusPercent ? (Math.abs(comparisonData!.versusPercent).toFixed(1) + '% ' + (comparisonData!.versusPercent >= 0 ? 'increase' : 'decrease') + ' versus previous period') : 'Previous period comparison not available'">
          {{ comparisonData!.formattedVersusPercent }}
        </span>
      </div>

      <!-- Previous Period Row -->
      <div class="period-row">
        <span class="period-row__label">Previous Period</span>
        <span class="period-row__value period-row__value--neutral">
          {{ comparisonData!.formattedPreviousPeriodValue }}
        </span>
      </div>
    </div>
  </div>

  <!-- No Data Template -->
  <ng-template #noDataTemplate>
    <div class="divider"></div>
    <div class="period-comparison">
      <div class="period-row">
        <span class="period-row__label">Versus</span>
        <span class="period-row__value" aria-label="Previous period comparison not available">—</span>
      </div>
      <div class="period-row">
        <span class="period-row__label">Previous Period</span>
        <span class="period-row__value period-row__value--neutral" aria-label="Previous period data not available">—</span>
      </div>
    </div>
  </ng-template>
</div>